var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.page && !_vm.loading)?[_c('h1',[_vm._v(_vm._s(_vm.page.title))]),_c('BlocksDispatcher',{attrs:{"blocks":_vm.page.blocks}})]:(_vm.error)?_c('div',[_vm._v(_vm._s(_vm.genericErrorMessage))]):_c('LoadingIndicator')],2)}
var staticRenderFns = []

export { render, staticRenderFns }